import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=42897d1a&"
import script from "./PageSizeSelect.vue?vue&type=script&lang=js&"
export * from "./PageSizeSelect.vue?vue&type=script&lang=js&"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42897d1a', component.options)
    } else {
      api.reload('42897d1a', component.options)
    }
    module.hot.accept("./PageSizeSelect.vue?vue&type=template&id=42897d1a&", function () {
      api.rerender('42897d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/datatable/PageSizeSelect.vue"
export default component.exports